// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { stringMustBeNumber } from 'validators/common'

const validate = v => {
  // Since redux-form v8, first render of the form does not have the actual initial values.
  // https://github.com/redux-form/redux-form/issues/4344
  if (Object.keys(v).length === 0) {
    return
  }

  const error = {}

  error['adv-beamwidth'] = stringMustBeNumber(v['adv-beamwidth'])
  error['adv-diameter'] = stringMustBeNumber(v['adv-diameter'])
  error['adv-gain'] = stringMustBeNumber(v['adv-gain'])
  error.frequency = stringMustBeNumber(v.frequency)

  return error
}

export default validate
